import { Component } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ai } from './TelemetryService';

class TelemetryProvider extends Component {
    constructor() {
        super();

        this.state = {
            initialized: false
        };
    }

    componentDidMount() {
        const { history } = this.props;
        const { initialized } = this.state;
        const AppInsightsInstrumentationKey = process.env.REACT_APP_APPINSIGHTS_KEY;
        if (!initialized && Boolean(AppInsightsInstrumentationKey) && Boolean(history)) {
            ai.initialize(AppInsightsInstrumentationKey, history);
            this.setState({ initialized: true });
        }
    }

    render() {
        const { children } = this.props;
        return children;
    }
}

TelemetryProvider.propTypes = {
    history: PropTypes.object,
    children: PropTypes.node
};

export default withRouter(withAITracking(ai.reactPlugin, TelemetryProvider));